import {Basic} from "./Basic";

export class NewsSlides
{
    constructor(containers)
    {
        for(let i=0; i<containers.length; i++)
        {
            containers[i].classList.add('mod--processed');
            const slides = containers[i].querySelectorAll('.w__module--media-slide');
            if(slides.length > 1)
            {
                Basic.insert_switchControls(containers[i], 'news-slide-switch');
            }
        }
    }

    static switch(el)
    {
        const container = el.closest('.w__module--media');
        const currentSlide = container.querySelector('.w__module--media-slide.active');
        const slides = container.querySelectorAll('.w__module--media-slide');
        let newSlide;

        if(el.classList.contains('mod--next'))
        {
            newSlide = currentSlide.nextElementSibling  && currentSlide.nextElementSibling.classList.contains('w__module--media-slide')
                ? currentSlide.nextElementSibling
                : slides[0];
        }
        else
        {
            newSlide = currentSlide.previousElementSibling && currentSlide.previousElementSibling.classList.contains('w__module--media-slide')
                ? currentSlide.previousElementSibling
                : slides[slides.length - 1];
        }

        const loadImage = newSlide.querySelector('.w__text--image.mod--load');

        if(loadImage)
        {
            NewsSlides.load_image(currentSlide, newSlide, loadImage);
        }
        else
        {
            NewsSlides.change_slide(currentSlide, newSlide);
        }
    }

    static change_slide(currentSlide, newSlide)
    {
        currentSlide.classList.remove('active');
        newSlide.classList.add('active');
    }

    static load_image(currentSlide, newSlide, loadImage)
    {
        // add waiting cursor
        document.documentElement.classList.add('w__waiting');
        loadImage.classList.remove('mod--load');

        // create image
        const src = Basic.adjust_imagePath(loadImage.href, currentSlide.getBoundingClientRect()['width'], parseInt(loadImage.dataset.width)),
              myImage = new Image;
        myImage.className = loadImage.className;
        myImage.src = src;
        myImage.alt = loadImage.textContent;

        myImage.addEventListener('load',() =>
        {
            // remove waiting cursor
            document.documentElement.classList.remove('w__waiting');
            loadImage.insertAdjacentElement('afterend', myImage)
            loadImage.remove();
            NewsSlides.change_slide(currentSlide, newSlide);
        });
    }
}